import { useState, RefObject } from 'react'
import { useMutationObserver } from 'shared/hooks'

const useNewTagAdded = (target: RefObject<any>, nodeName: string) => {
  const [tagAdded, setAddedTag] = useState(false)

  useMutationObserver({
    target,
    options: {
      childList: true,
      subtree: true
    },
    callback: (mutationRecord) => {
      const iframeAdded = mutationRecord.reduce<Node | undefined>((acc, curr) => {
        const iframe = Array.from(curr.addedNodes).find((node) => node.nodeName === nodeName)
        if (iframe) {
          acc = iframe
        }
        return acc
      }, undefined)

      if (iframeAdded) {
        iframeAdded.addEventListener('load', () => setAddedTag(true))
      }
    }
  })

  return tagAdded
}

export default useNewTagAdded
